let logoutTriggered = false;

export const authEvents = {
  triggerLogoutOnce(callback) {
    if (logoutTriggered) {
      return;
    }

    logoutTriggered = true;
    if (typeof callback === 'function') {
      callback();
    }
  },

  reset() {
    logoutTriggered = false;
  },
};
